export const featureTogglesConstants = {
    GET_FEATURE_TOGGLES_REQUEST: 'GET_FEATURE_TOGGLES_REQUEST',
    GET_FEATURE_TOGGLES_SUCCESS: 'GET_FEATURE_TOGGLES_SUCCESS',
    GET_FEATURE_TOGGLES_ERROR: 'GET_FEATURE_TOGGLES_ERROR'
};
